import { isKeyMatched } from './general';
export const handleExpandCollapse = (e, keyPressFunctions, _ref) => {
  let {
    expanded,
    selected,
    hashTable,
    setExpanded,
    onExpand,
    itemId
  } = _ref;
  e.stopPropagation();
  let newExpanded = [...expanded];
  if (isKeyMatched(e, keyPressFunctions.collapse)) {
    if (newExpanded.includes(itemId)) {
      newExpanded = newExpanded.filter(expandedId => expandedId != itemId);
    } else {
      return;
    }
  } else if (isKeyMatched(e, keyPressFunctions.expand)) {
    e.preventDefault();
    if (!newExpanded.includes(itemId)) {
      newExpanded.push(itemId);
    } else {
      return;
    }
  } else {
    newExpanded = newExpanded.includes(itemId) ? newExpanded.filter(expandedId => expandedId != itemId) : [...newExpanded, itemId];
  }
  setExpanded(newExpanded);
  const args = [e, newExpanded, selected, ...(hashTable ? [{
    expandedRecords: newExpanded.map(id => hashTable.get(id)) || [],
    selectedRecords: selected.map(id => hashTable.get(id)) || []
  }] : [])];
  onExpand(...args);
};
export const handleSelect = (e, _ref2) => {
  let {
    selected,
    setSelected,
    onSelect,
    multiSelect,
    itemId
  } = _ref2;
  let newSelectedIds = [...selected];
  const index = selected.indexOf(itemId);
  if (index >= 0) {
    // if item clicked on is already present in the selected list
    multiSelect ? newSelectedIds.splice(index, 1) : newSelectedIds = [];
  } else {
    multiSelect ? newSelectedIds.push(itemId) : newSelectedIds = [itemId];
  }
  setSelected(newSelectedIds);
  onSelect(e, newSelectedIds);
};
export const handleSelectAndClose = (e, _ref3) => {
  let {
    selected,
    expanded,
    hashTable,
    setSelected,
    onSelect,
    itemId,
    close
  } = _ref3;
  let newSelectedIds = [...selected];
  const index = selected.indexOf(itemId);
  let newSelection = true;
  if (index >= 0) {
    // if item clicked on is already present in the selected list
    newSelection = false;
  } else {
    newSelectedIds = [itemId];
  }
  const args = [e, expanded, newSelectedIds, ...(hashTable ? [{
    expandedRecords: expanded.map(id => hashTable.get(id)) || [],
    selectedRecords: newSelectedIds.map(id => hashTable.get(id)) || []
  }] : [])];
  onSelect(...args);
  close();
  if (newSelection) {
    setSelected(newSelectedIds);
  } else return;
};